import type { UserDataLoginRecord, UserGroupType } from '@navio/nsdk';

import { tracking } from './index';
import {
  resolveSelectedUserGroup,
  toUserGroupAnalyticsGroups,
  USER_GROUP_ANALYTICS_TYPES
} from './userGroupAnalyticsGroups';

type AnalyticsUserGroup = {
  id: number;
  name: string;
  isOrganization: boolean;
  isSelected: boolean;
  type: UserGroupType;
};

/** Identify actor + attach org/user_group analytics for the active workspace. */
export function syncUserGroupAnalytics(args: {
  actor: UserDataLoginRecord;
  sessionUserGroups: AnalyticsUserGroup[];
  selectedGroupId: number | undefined;
  impersonatedUserId?: string;
}) {
  tracking.identify(args.actor);
  tracking.setSessionProps({
    set: {
      impersonating: Boolean(args.impersonatedUserId),
      ...(args.impersonatedUserId ? { impersonatedUserId: args.impersonatedUserId } : {})
    },
    drop: args.impersonatedUserId ? [] : ['impersonatedUserId']
  });
  tracking.setGroups(
    toUserGroupAnalyticsGroups(resolveSelectedUserGroup(args.sessionUserGroups, args.selectedGroupId)),
    { types: USER_GROUP_ANALYTICS_TYPES }
  );
}

export function clearUserGroupAnalytics() {
  tracking.setSessionProps({ drop: ['impersonating', 'impersonatedUserId'] });
  tracking.setGroups([], { types: USER_GROUP_ANALYTICS_TYPES });
}
